/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTenantRequest,
  OkResponse,
  PatchTenantRequest,
  TenantRecordResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiTenantsUrl = () => {




  return `/api/tenants`
}

export const postApiTenants = async (createTenantRequest: CreateTenantRequest, options?: RequestInit): Promise<TenantRecordResponse> => {

  return orvalControlFetch<TenantRecordResponse>(getPostApiTenantsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTenantRequest,)
  }
);}




export const getPostApiTenantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTenants>>, TError,{data: CreateTenantRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTenants>>, TError,{data: CreateTenantRequest}, TContext> => {

const mutationKey = ['postApiTenants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTenants>>, {data: CreateTenantRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTenants(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTenants>>>
    export type PostApiTenantsMutationBody = CreateTenantRequest
    export type PostApiTenantsMutationError = unknown

    export const usePostApiTenants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTenants>>, TError,{data: CreateTenantRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTenants>>,
        TError,
        {data: CreateTenantRequest},
        TContext
      > => {
      return useMutation(getPostApiTenantsMutationOptions(options), queryClient);
    }
    export const getGetApiTenantsUrl = () => {




  return `/api/tenants`
}

export const getApiTenants = async ( options?: RequestInit): Promise<TenantRecordResponse[]> => {

  return orvalControlFetch<TenantRecordResponse[]>(getGetApiTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiTenantsQueryKey = () => {
    return [
    `/api/tenants`
    ] as const;
    }


export const getGetApiTenantsQueryOptions = <TData = Awaited<ReturnType<typeof getApiTenants>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTenants>>> = ({ signal }) => getApiTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTenants>>>
export type GetApiTenantsQueryError = unknown


export function useGetApiTenants<TData = Awaited<ReturnType<typeof getApiTenants>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenants>>,
          TError,
          Awaited<ReturnType<typeof getApiTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenants<TData = Awaited<ReturnType<typeof getApiTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenants>>,
          TError,
          Awaited<ReturnType<typeof getApiTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenants<TData = Awaited<ReturnType<typeof getApiTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTenants<TData = Awaited<ReturnType<typeof getApiTenants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenants>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTenantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiTenantsTenantIdUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}`
}

export const getApiTenantsTenantId = async (tenantId: string, options?: RequestInit): Promise<TenantRecordResponse> => {

  return orvalControlFetch<TenantRecordResponse>(getGetApiTenantsTenantIdUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiTenantsTenantIdQueryKey = (tenantId: string,) => {
    return [
    `/api/tenants/${tenantId}`
    ] as const;
    }


export const getGetApiTenantsTenantIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError = unknown>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTenantsTenantIdQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTenantsTenantId>>> = ({ signal }) => getApiTenantsTenantId(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTenantsTenantIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTenantsTenantId>>>
export type GetApiTenantsTenantIdQueryError = unknown


export function useGetApiTenantsTenantId<TData = Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError = unknown>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenantsTenantId>>,
          TError,
          Awaited<ReturnType<typeof getApiTenantsTenantId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenantsTenantId<TData = Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenantsTenantId>>,
          TError,
          Awaited<ReturnType<typeof getApiTenantsTenantId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenantsTenantId<TData = Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTenantsTenantId<TData = Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTenantsTenantIdQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPatchApiTenantsTenantIdUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}`
}

export const patchApiTenantsTenantId = async (tenantId: string,
    patchTenantRequest: PatchTenantRequest, options?: RequestInit): Promise<TenantRecordResponse> => {

  return orvalControlFetch<TenantRecordResponse>(getPatchApiTenantsTenantIdUrl(tenantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchTenantRequest,)
  }
);}




export const getPatchApiTenantsTenantIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiTenantsTenantId>>, TError,{tenantId: string;data: PatchTenantRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiTenantsTenantId>>, TError,{tenantId: string;data: PatchTenantRequest}, TContext> => {

const mutationKey = ['patchApiTenantsTenantId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiTenantsTenantId>>, {tenantId: string;data: PatchTenantRequest}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  patchApiTenantsTenantId(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiTenantsTenantIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiTenantsTenantId>>>
    export type PatchApiTenantsTenantIdMutationBody = PatchTenantRequest
    export type PatchApiTenantsTenantIdMutationError = unknown

    export const usePatchApiTenantsTenantId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiTenantsTenantId>>, TError,{tenantId: string;data: PatchTenantRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiTenantsTenantId>>,
        TError,
        {tenantId: string;data: PatchTenantRequest},
        TContext
      > => {
      return useMutation(getPatchApiTenantsTenantIdMutationOptions(options), queryClient);
    }
    export const getDeleteApiTenantsTenantIdUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}`
}

export const deleteApiTenantsTenantId = async (tenantId: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiTenantsTenantIdUrl(tenantId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiTenantsTenantIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiTenantsTenantId>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiTenantsTenantId>>, TError,{tenantId: string}, TContext> => {

const mutationKey = ['deleteApiTenantsTenantId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiTenantsTenantId>>, {tenantId: string}> = (props) => {
          const {tenantId} = props ?? {};

          return  deleteApiTenantsTenantId(tenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiTenantsTenantIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiTenantsTenantId>>>

    export type DeleteApiTenantsTenantIdMutationError = unknown

    export const useDeleteApiTenantsTenantId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiTenantsTenantId>>, TError,{tenantId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiTenantsTenantId>>,
        TError,
        {tenantId: string},
        TContext
      > => {
      return useMutation(getDeleteApiTenantsTenantIdMutationOptions(options), queryClient);
    }
